import { render } from "./AdminCourseOssView.vue?vue&type=template&id=dbd571ac&scoped=true"
import script from "./AdminCourseOssView.vue?vue&type=script&lang=js"
export * from "./AdminCourseOssView.vue?vue&type=script&lang=js"

import "./AdminCourseOssView.vue?vue&type=style&index=0&id=dbd571ac&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd571ac"]])

export default __exports__